// @noflow
import { getProductsLoadedAt, makeGetProductItemById } from '~/core/state/products/selectors';
import { setBoostHeatingHotwater, timeoutBoostHeatingHotwater } from '~/core/state/products/heating-hotwater/actions';

import { BOOST_DURATION } from '~/core/constants/app-settings';
import { buildKey } from '~/core/utils/app-settings';
import { connect } from 'react-redux';
import { flowRight } from 'lodash/fp';
import { getAppSetting } from '~/core/state/app-settings/selectors';
import { getConfig } from '~/core/state/config/selectors';
import { getThermostatControlMode } from '~/core/state/products/thermostat/selectors';
import HotwaterBoost from './component';
import moment from 'moment-timezone';

const mapStateToProps = (state, { id }) => {
    const getProductItemById = makeGetProductItemById();

    const controlMode = getThermostatControlMode(state, { id });
    const cookieDuration = getAppSetting(state, buildKey(BOOST_DURATION, controlMode, id));
    const defaultDuration = getConfig(state, 'products:hotwater:defaultBoostDuration');
    const selectedTime = parseInt(cookieDuration || defaultDuration, 10);

    const product = getProductItemById(state, { id });
    const loadedAt = getProductsLoadedAt(state);
    const remaining = product.getIn(['state', 'boost']);

    const elapsed = moment().diff(loadedAt, 'minutes');
    const duration = Math.max(0, remaining - elapsed);

    if (!duration) {
        timeoutBoostHeatingHotwater({ productId: id });
    }

    return {
        selectedTime,
        duration,
        showDropDown: false,
        controlMode: controlMode.toLowerCase()
    };
};

const mapDispatchToProps = (dispatch, { id }) => {
    return {
        setBoost: flowRight(dispatch, (duration, controlMode) =>
            setBoostHeatingHotwater({
                productId: id,
                duration,
                controlMode,
                loadedAt: new Date()
            })
        )
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(HotwaterBoost);



// WEBPACK FOOTER //
// ./src/components/widgets/boost/index.js